import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import type { PostPricePredictionParams, PricePrediction, PricePredictionMe } from './types';

export * from './types';

export const fetchPricePredictionApi = (id: string) => fetchClient.fetch<PricePrediction>(`/v1/price-prediction/${id}`);

export const getPricePrediction = (id: string) => apiClient.get<PricePrediction>(`/v1/price-prediction/${id}`);

export const getPricePredictionMe = (id: string) => apiClient.get<PricePredictionMe>(`/v1/price-prediction/${id}/me`);

export const postPricePrediction = (id: string, data: PostPricePredictionParams) =>
  apiClient.post(`/v1/price-prediction/${id}`, data);
